import {
  LIST_CATEGORIA_INIT,
  LIST_CATEGORIA_SUCCESS,
  CREATE_CATEGORIA_INIT,
  CREATE_CATEGORIA_SUCCESS,
  UPDATE_CATEGORIA_INIT,
  UPDATE_CATEGORIA_SUCCESS,
  DELETE_CATEGORIA_INIT,
  DELETE_CATEGORIA_SUCCESS,
  CATEGORIA_ERROR_MSG,
  CLEAR_CATEGORIA
} from '../actionTypes';

const INIT_STATE = {
  loading: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false,
  isError: false,
  categorias: [],
  msg: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LIST_CATEGORIA_INIT:
      return { ...state, loading: true };
    case LIST_CATEGORIA_SUCCESS: {
      const { categorias } = action.payload;
      return {
        ...state,
        categorias,
        loading: false
      };
    }
    case CREATE_CATEGORIA_INIT:
      return {
        ...state,
        isCreated: false,
        isUpdated: false,
        isDeleted: false,
        isError: false,
        msg: ''
      };
    case CREATE_CATEGORIA_SUCCESS: {
      const { msg, isCreated } = action.payload;
      return {
        ...state,
        msg,
        isCreated,
        isError: false
      };
    }
    case UPDATE_CATEGORIA_INIT:
      return {
        ...state,
        isCreated: false,
        isUpdated: false,
        isDeleted: false,
        isError: false,
        msg: ''
      };
    case UPDATE_CATEGORIA_SUCCESS: {
      const { msg, isUpdated } = action.payload;

      return {
        ...state,
        msg,
        isUpdated,
        isError: false
      };
    }
    case DELETE_CATEGORIA_INIT:
      return {
        ...state,
        isCreated: false,
        isUpdated: false,
        isDeleted: false,
        isError: false,
        msg: ''
      };
    case DELETE_CATEGORIA_SUCCESS: {
      const { msg, isDeleted } = action.payload;
      return {
        ...state,
        msg,
        isDeleted,
        isError: false
      };
    }
    case CATEGORIA_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, isError: true, msg };
    }
    case CLEAR_CATEGORIA: {
      return {
        ...state,
        isUpdated: false,
        isCreated: false,
        isDeleted: false,
        isError: false,
        msg: ''
      };
    }
    default:
      return { ...state };
  }
};
